'use client';

import { type ComponentPropsWithoutRef, forwardRef, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type InputProps = ComponentPropsWithoutRef<'input'>;

export const Input = memo(
  forwardRef<HTMLInputElement, InputProps>(({ className, ...restOfProps }, forwardedRef) => {
    return (
      <input
        className={cn(
          'h-10 rounded-8 border border-neutral-6 bg-white px-4 text-12 text-neutral-12 placeholder:text-neutral-9 focus:border-brand-9 focus:outline-none focus:ring-2 focus:ring-brand-9/20 dark:bg-neutral-1',
          className,
        )}
        {...restOfProps}
        ref={forwardedRef}
      />
    );
  }),
);

Input.displayName = 'Input';
